'use client';

import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import BrandPanel from './BrandPanel';

export type AuthMode = 'login' | 'signup';

export default function AuthScreen() {
  const [mode, setMode] = useState<AuthMode>('signup');

  return (
    <div className="min-h-screen flex">
      {/* Left brand panel */}
      <BrandPanel />

      {/* Right form panel */}
      <div className="flex-1 flex flex-col justify-center items-center px-6 py-12 bg-[#0f0f1a] lg:px-16 xl:px-24">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden mb-8 flex items-center gap-3">
            <div className="w-9 h-9 bg-[#c9a96e] rounded-lg flex items-center justify-center">
              <span className="text-[#1a1a2e] text-lg">✦</span>
            </div>
            <span className="font-display text-xl text-white">Captures</span>
          </div>

          {/* Heading */}
          {mode === 'signup' &&
          <div className="mb-7">
              <h2 className="font-display text-3xl text-white mb-1.5">Book Your Session</h2>
              <p className="text-gray-400 text-sm">Enter your name and choose a service to get started.</p>
            </div>
          }

          <div className="animate-fade-in">
            {mode === 'login' ?
            <LoginForm onSwitchMode={() => setMode('signup')} /> :

            <SignUpForm onSwitchMode={() => setMode('login')} />
            }
          </div>

          {/* Admin sign-in link */}
          {mode === 'signup' &&
          <p className="mt-6 text-center text-xs text-gray-500">
              Photographer?{' '}
              <button
              onClick={() => setMode('login')}
              className="text-[#c9a96e] hover:underline font-medium">

                Admin sign in
              </button>
            </p>
          }
        </div>
      </div>
    </div>);

}